import * as React from "react"

function BigArrow(props) {
  return (
    <svg
      width={24}
      height={10}
      viewBox="0 0 24 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.797 3.801a.796.796 0 000 1.593V3.801zm23.098.797L15.93-.001v9.197l7.965-4.598zm-23.098 0v.796h15.93V3.801H.796v.797z"
        fill="#fff"
      />
    </svg>
  )
}

export default BigArrow